




















































import { defineComponent, ref } from '@vue/composition-api';

import DetailOptionsButton from '@/components/common/DetailOptionsButton.vue';
import DeleteConfirmationDialog from '@/components/common/DeleteConfirmationDialog.vue';

export default defineComponent({
  name: 'WorkflowFormBuilderFieldOptionsButton',

  components: {
    DeleteConfirmationDialog,
    DetailOptionsButton
  },

  props: {
    label: {
      type: String
    }
  },

  setup(props, { emit }) {
    const isDeleteInProgress = ref(false);

    const deleteFieldDialog = ref(false);

    function cancelFieldDeleteDialog() {
      deleteFieldDialog.value = false;
    }

    function removeTemplateSectionField() {
      emit('remove-field-pressed');
    }

    return {
      deleteFieldDialog,
      isDeleteInProgress,

      cancelFieldDeleteDialog,
      removeTemplateSectionField
    };
  }
});
